export enum FlowType {
    DEFAULT = 'DEFAULT',
    NSPK = 'NSPK',
    TPAY = 'TPAY',
    SBERPAY = 'SBERPAY',
    ALFAPAY = 'ALFAPAY',
    VTBPAY = 'VTBPAY',
    GPBPAY = 'GPBPAY',
    PSBPAY = 'PSBPAY',
    OZONPAY = 'OZONPAY',
    WBPAY = 'WBPAY',
    SOVKOMPAY = 'SOVKOMPAY',
    SBP_QR = 'SBP_QR',
    MANUAL_SBP_QR = 'MANUAL_SBP_QR',
    CLICK_QR = 'CLICK_QR',
    VIET_QR = 'VIET_QR',
    IND_QR = 'IND_QR',
    BR_QR = 'BR_QR',
    TO_BANK_DETAILS = 'TO_BANK_DETAILS',
    CARD_ACQUIRING = 'CARD_ACQUIRING',
    MANUAL_ECOM = 'MANUAL_ECOM',
    CARD_ACQUIRING_REDIRECT = 'CARD_ACQUIRING_REDIRECT',
}
